/*! fc-analytics.js, Foot Cardigan storefront customer-event layer.
 *  Fires every event to BOTH window.dataLayer (GA4 / GTM) and the Amplitude
 *  SDK that is already loaded on the page. Context (page type, product,
 *  collection) is injected by snippets/fc-analytics.liquid before this loads.
 *  Checkout-funnel events live in the separate Shopify Customer-Events pixel. */
(function () {
  'use strict';
  var FC = (window.FCAnalytics = window.FCAnalytics || {});
  FC.debug = /[?&]fc_debug=1/.test(location.search) || FC.debug;

  /* ---------- core dispatch ---------- */
  function ampReady() { return window.amplitude && typeof window.amplitude.track === 'function'; }
  var ampQueue = [];
  function flushAmp() { if (!ampReady()) return; while (ampQueue.length) { var e = ampQueue.shift(); try { window.amplitude.track(e.n, e.p); } catch (x) {} } }

  function track(name, props) {
    props = props || {};
    try { props.page_type = FC.pageType; props.template = FC.template; props.path = location.pathname; } catch (x) {}
    try { window.dataLayer = window.dataLayer || []; var dl = {}; for (var k in props) dl[k] = props[k]; dl.event = name; window.dataLayer.push(dl); } catch (x) {}
    try { if (ampReady()) window.amplitude.track(name, props); else ampQueue.push({ n: name, p: props }); } catch (x) {}
    if (FC.debug) { try { console.log('%c[fc-analytics]', 'color:#2A6FB5', name, props); } catch (x) {} }
  }
  FC.track = track;
  var ampTimer = setInterval(function () { if (ampReady()) { flushAmp(); clearInterval(ampTimer); } }, 400);
  setTimeout(function () { clearInterval(ampTimer); }, 20000);

  /* ---------- helpers ---------- */
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function throttle(fn, ms) { var t = 0; return function () { var n = Date.now(); if (n - t >= ms) { t = n; fn(); } }; }
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim().slice(0, 80); }
  function sectionOf(el) {
    var s = el.closest('[data-fc-section],section,[class*="fcv2-"],[class*="cs-sec"],footer,header');
    if (!s) return '';
    if (s.getAttribute('data-fc-section')) return s.getAttribute('data-fc-section');
    var h = s.querySelector('h1,h2,h3');
    if (h && h.innerText) return clean(h.innerText).slice(0, 48);
    return clean(s.className).split(' ')[0] || s.tagName.toLowerCase();
  }
  function ecItem(p) { return { item_id: String(p.id || ''), item_name: p.name, price: p.price, item_brand: p.vendor, item_category: p.type, item_handle: p.handle }; }

  /* ---------- add-to-cart interception (AJAX + form) ---------- */
  function emitAddToCart(data, source) {
    var item = {};
    try {
      item = {
        item_id: String((data && (data.product_id || data.id)) || ''),
        item_name: (data && (data.product_title || data.title)) || (FC.product && FC.product.name) || '',
        price: data && data.price != null ? data.price / 100 : (FC.product && FC.product.price),
        quantity: (data && data.quantity) || 1,
        variant_id: String((data && data.variant_id) || (data && data.id) || ''),
        selling_plan: (data && data.selling_plan_allocation && data.selling_plan_allocation.selling_plan && data.selling_plan_allocation.selling_plan.name) || (data && data.selling_plan) || null
      };
    } catch (x) {}
    track('add_to_cart', { source: source || 'ajax', item_id: item.item_id, item_name: item.item_name, price: item.price, quantity: item.quantity, variant_id: item.variant_id, selling_plan: item.selling_plan });
  }
  function patchFetch() {
    if (!window.fetch || window.__fcFetchPatched) return; window.__fcFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string' ? input : (input && input.url)) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?/.test(url)) {
        p.then(function (res) { try { res.clone().json().then(function (d) { emitAddToCart(d, 'ajax'); }).catch(function () { emitAddToCart({}, 'ajax'); }); } catch (x) { emitAddToCart({}, 'ajax'); } }).catch(function () {});
      }
      return p;
    };
    // XHR fallback
    try {
      var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { this.__fcUrl = u; return open.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () { var xhr = this; if (/\/cart\/add(\.js)?/.test(xhr.__fcUrl || '')) { xhr.addEventListener('load', function () { var d = {}; try { d = JSON.parse(xhr.responseText); } catch (x) {} emitAddToCart(d, 'ajax'); }); } return send.apply(this, arguments); };
    } catch (x) {}
  }

  /* ---------- init ---------- */
  ready(function () {
    track('page_view', { title: document.title, referrer: document.referrer });
    if (FC.product) track('view_item', ecItem(FC.product));
    if (FC.collection) track('view_item_list', { list_name: FC.collection.title, list_id: FC.collection.handle, item_count: FC.collection.count });
    if (FC.pageType === 'cart') track('view_cart', {});

    patchFetch();

    /* clicks: CTAs, links, checkout, product cards, add-to-cart forms */
    document.addEventListener('click', function (e) {
      var el = e.target.closest('a,button,[role="button"]'); if (!el) return;
      var txt = clean(el.innerText || el.value || el.getAttribute('aria-label'));
      var href = el.getAttribute('href') || '';
      var section = sectionOf(el);
      if (el.name === 'checkout' || /\/checkout/.test(href) || /\bcheckout\b/i.test(el.getAttribute('data-fc') || '')) { track('begin_checkout', { source: section }); return; }
      if (el.matches('[name="add"],.add-to-cart,[data-add-to-cart],button[type="submit"][form*="product"]')) { track('add_to_cart_click', { section: section, text: txt }); }
      var card = el.closest('a[href*="/products/"]');
      if (card && FC.pageType === 'collection') { track('select_item', { item_name: clean(card.innerText).slice(0, 48), item_handle: (card.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1] }); }
      if (el.matches('.cs-btn,.fcv2-seccta .cta,[data-fc-cta],.button,.btn') || /→|get |start |gift |see |request |quote|design|subscribe|join|shop/i.test(txt)) {
        track('cta_click', { cta_text: txt, cta_href: href, section: section });
      } else if (href && href.charAt(0) !== '#' && txt) {
        track('link_click', { text: txt, href: href, section: section });
      }
    }, true);

    /* FAQ accordions */
    document.addEventListener('toggle', function (e) {
      var d = e.target; if (d && d.tagName === 'DETAILS' && d.open) { var s = d.querySelector('summary'); track('faq_open', { question: clean((s && s.innerText || '').replace(/\s*\+\s*$/, '')).slice(0, 100), section: sectionOf(d) }); }
    }, true);

    /* form submits: add-to-cart, search, newsletter */
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || f.tagName !== 'FORM') return; var action = f.getAttribute('action') || '';
      if (/\/cart\/add/.test(action)) { track('add_to_cart', { source: 'form', section: sectionOf(f) }); }
      else if (/\/search/.test(action) || f.querySelector('input[name="q"]')) { var q = (f.querySelector('input[name="q"]') || {}).value || ''; track('search', { query: clean(q) }); }
      else if ((f.querySelector('input[type="email"]')) && /newsletter|footer|customer|contact|subscribe/i.test((action + ' ' + f.className + ' ' + (f.id || '')))) { track('newsletter_signup', { location: sectionOf(f) }); }
    }, true);

    /* section views */
    try {
      if ('IntersectionObserver' in window) {
        var seen = {};
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) { var id = sectionOf(en.target); if (id && !seen[id]) { seen[id] = 1; track('section_view', { section: id }); } } });
        }, { threshold: 0.45 });
        document.querySelectorAll('[data-fc-section],.fcv2-hero,.fcv2-band,.fcv2-reviews,.fcv2-faq,.fcv2-reel,.fcv2-flow,.fcv2-unbox,.cs-sec').forEach(function (s) { io.observe(s); });
      }
    } catch (x) {}

    /* scroll depth */
    var marks = [25, 50, 75, 90], hit = {};
    window.addEventListener('scroll', throttle(function () {
      var h = document.documentElement; var pct = Math.round((window.scrollY + window.innerHeight) / h.scrollHeight * 100);
      marks.forEach(function (m) { if (pct >= m && !hit[m]) { hit[m] = 1; track('scroll_depth', { percent: m }); } });
    }, 400), { passive: true });

    /* time-on-page engagement (15s, 30s, 60s) */
    [15, 30, 60].forEach(function (s) { setTimeout(function () { if (!document.hidden) track('engaged_time', { seconds: s }); }, s * 1000); });
  });
})();
